//
// Original collection by Kjetil Midtgarden Golid
// https://github.com/kgolid/chromotome
// https://kgolid.github.io/chromotome-site/
//
export default [
  {
    name: 'rag-mysore',
    colors: ['#ec6c26', '#613a53', '#e8ac52', '#639aa0'],
    background: '#d5cda1',
    type: 'ranganath',
  },
  {
    name: 'rag-gol',
    colors: ['#d3693e', '#803528', '#f1b156', '#90a798'],
    background: '#f0e0a4',
    type: 'ranganath',
  },
  {
    name: 'rag-belur',
    colors: ['#f46e26', '#68485f', '#3d273a', '#535d55'],
    background: '#dcd4a6',
    type: 'ranganath',
  },
  {
    name: 'rag-bangalore',
    colors: ['#ea720e', '#ca5130', '#e9c25a', '#52534f'],
    background: '#f9ecd3',
    type: 'ranganath',
  },
  {
    name: 'rag-taj',
    colors: ['#ce565e', '#8e1752', '#f8a100', '#3ac1a6'],
    background: '#efdea2',
    type: 'ranganath',
  },
  {
    name: 'rag-virupaksha',
    colors: ['#f5736a', '#925951', '#feba4c', '#9d9b9d'],
    background: '#eedfa2',
    type: 'ranganath',
  },
];
